import React, { useRef, useState } from 'react';
// import { FeaturedCreatorProductType } from '@/types/marketplace.interface';
import styles from './index.module.less';
import classNames from 'classnames';
import { getPathTitle, imgUrl } from '@/shared/utils';
// import { useConfigProvider } from '@/context/ConfigProvider';
import { Input } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import { ActionType, ProList } from '@ant-design/pro-components';
import { useRouter } from 'next/router';
import useScreenSize from '@/lib/hooks/utils/useScreenSize';
import _ from 'lodash';
import { getBooksListData, getGptsListSearchData } from '@/lib/service';
import { BaseBookModel } from '@/types/home';
import EmptyPage from '../Common/Empty';
import Image from 'next/image';
import { useTranslation } from 'next-i18next';
import Link from 'next/link';
import RecommendedBookItem from '../Common/BookListItem';

const BooksListContent = () => {
  // const { isMobile } = useConfigProvider();
  const router = useRouter();
  const { width } = useScreenSize();
  // const [searchValue, setSearchValue] = useState<string>();
  const actionRef = useRef<ActionType>();
  const [showEmpty, setShowEmpty] = useState<boolean>(false);
  const { t } = useTranslation('common');
  const divRef = useRef<HTMLDivElement>(null);

  const columnSize = () => {
    if (width >= 1000) {
      return 4;
    }
    if (width >= 750) {
      return 3;
    }
    if (width >= 550) {
      return 2;
    }
    return 1;
  };

  return (
    <div className={styles.popularProductsContainer} ref={divRef}>
      <div className={styles.homeContent}>
        <div className={styles.titleContainer}>
          <h1 className={styles.title}>{t('DarkRomanceFeaturedBooks')}</h1>
          <p className={styles.desc}>{t('DarkRomanceFeaturedBooks_Desc')}</p>
        </div>

        <div className={styles.rowListContainer}>
          <ProList<any>
            className={styles.proListContainer}
            actionRef={actionRef}
            ghost={true}
            // emptyText={}
            pagination={{
              defaultPageSize: 20,
              showSizeChanger: false,
              align: 'center',
              showTotal: null,
            }}
            showActions="always"
            grid={{ gutter: 15, column: columnSize() }}
            // onItem={(record: BaseBookModel) => {
            //   return {
            //     onClick: () => {
            //       if (record?.id != undefined) {
            //         router.push(
            //           `/recommended-books/${record?.id}/${getPathTitle(record?.book_name)}`,
            //         );
            //       }
            //     },
            //   };
            // }}
            itemCardProps={{
              style: {
                width: '100%',
                border: 0,
                background: `var(--foreground-rgb)`,
                borderRadius: 0,
              },
              bodyStyle: {
                padding: 0,
              },
            }}
            metas={{
              content: {
                render: (_, reacd: BaseBookModel) => {
                  return (
                    <div className={styles.cardContainer}>
                      <RecommendedBookItem data={reacd} />
                    </div>
                  );
                },
              },
            }}
            request={async (params: any) => {
              const res = await getBooksListData(
                {
                  // title: searchValue,
                  page_no: params.current,
                  page_size: params.pageSize,
                }
              );

              if (divRef.current) {
                window.scrollTo({ top: 0 });
              }

              setShowEmpty(res == undefined || (res?.data?.length ?? 0) == 0);
              return {
                ...res,
                data: res.data,
              };
            }}
          />
          <div className={styles.empty} style={{ display: showEmpty ? 'block' : 'none' }}>
            <EmptyPage />
          </div>
        </div>
      </div>
    </div>
  );
};

export default BooksListContent;
